import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import fr from './locales/fr.json';

/** Backoffice supported languages: English, Spanish, Portuguese, Russian, French */
export const SUPPORTED_LANGS = ['en', 'es', 'pt', 'ru', 'fr'];

const resources = {
  en: { translation: en },
  es: { translation: es },
  pt: { translation: pt },
  ru: { translation: ru },
  fr: { translation: fr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGS,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'backoffice_lang',
    },
  });

/**
 * Normalize API user lang to a supported backoffice locale.
 * Accepts e.g. 'en', 'es', 'pt', 'pt-BR', 'ru', 'fr'.
 */
export function normalizeUserLang(lang) {
  if (!lang || typeof lang !== 'string') return null;
  const code = lang.split('-')[0].toLowerCase();
  return SUPPORTED_LANGS.includes(code) ? code : null;
}

export default i18n;
